module.exports = __webpack_public_path__ + "img/new_22_4.ed76734c.jpg";